<template>
  <ContractForm mode="create" />
</template>

<script>
import ContractForm from './form.vue';

export default {
  name: 'ContractCreate',
  components: { ContractForm },
};
</script>
